export default __webpack_public_path__ + "static/media/logo-inicio.f15b0a28.svg";